import { useLocation, Outlet } from "react-router-dom";
import {
  LayoutDashboard, Receipt, Package, Cog, Bot, FileText
} from "lucide-react";
import HubSidebar from "@/components/HubSidebar"
import TopNav from "@/components/TopNav"
import HubSwitcher from "@/components/HubSwitcher";

const NAV_ITEMS = [
  {
    id: "dashboard",
    label: "Dashboard",
    icon: LayoutDashboard,
    path: "/erp/dashboard",
    description: "KPI overview & AI suggestions"
  },
  {
    id: "finance",
    label: "Finance",
    icon: Receipt,
    path: "/erp/finance",
    description: "GL, AP, AR, trial balance & cash forecast"
  },
  {
    id: "scm",
    label: "SCM",
    icon: Package,
    path: "/erp/scm",
    description: "Materials, inventory & purchase orders"
  },
  {
    id: "production",
    label: "Production",
    icon: Cog,
    path: "/erp/production",
    description: "BOM, work centers & production orders"
  },
  {
    id: "assistant",
    label: "AI Assistant",
    icon: Bot,
    path: "/erp/assistant",
    description: "Joule-like ERP copilot"
  },
  {
    id: "documents",
    label: "Documents",
    icon: FileText,
    path: "/erp/documents",
    description: "AI document processing & extraction"
  }
];

export default function ERPLayout() {
  const location = useLocation();

  return (
    <>
    <TopNav />
    <div className="min-h-screen bg-app flex flex-col md:flex-row">
      <HubSidebar
        navItems={NAV_ITEMS}
        title="AllBaise ERP"
        subtitle="Enterprise Resource Planning"
        icon={LayoutDashboard}
        gradient="from-indigo-500 to-purple-600"
        activeBg="bg-indigo-500"
      />

      <main className="flex-1 overflow-auto flex">
        <div className="flex-1 min-w-0 p-4">
          <Outlet />
        </div>
        <div className="hidden lg:block w-40 shrink-0 p-3 border-l border-app">
          <HubSwitcher />
        </div>
      </main>
    </div>
    </>
  );
}
